var map = {
	"./BranchControlledItems.png": 1306,
	"./BranchControlledItems2.png": 1012,
	"./BranchEmployees.png": 3954,
	"./BranchPaymentMethods.png": 5102,
	"./BranchShift.png": 6086,
	"./BranchShift2.png": 2918,
	"./BranchVendor.png": 5733,
	"./EndOfDaySummary.png": 4981,
	"./FuelCost.png": 4621,
	"./FuelCreditSales.png": 3617,
	"./FuelTank.png": 9649,
	"./Login.png": 6702,
	"./Rekonsi-Final.svg": 8926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5680;